// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Обёртка всей формы */
.IssueCheck_formContainer__bZVVX {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 10px;
  padding-bottom: 70px;
  overflow-y: auto;
  background-color: #fdfdfd;
  font-family: sans-serif;
}

/* Заголовок */
.IssueCheck_heading__2t0dU {
  margin-top: 0;
  text-align: center;
  font-size: 1.4rem;
}

/* Статусы обработки */
.IssueCheck_statusError__sVAUf     { color: red;           font-weight: bold; }
.IssueCheck_statusPending__SILyK   { color: #ff9800;       }
.IssueCheck_statusCompleted__3L\\+84 { color: rgb(0, 123, 255); }
.IssueCheck_statusUnknown__bsV4b   { color: #607d8b;       }

/* Информация о квитанции */
.IssueCheck_receiptInfoCheck__Um8in {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  padding: 10px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.IssueCheck_receiptInfoCheck__Um8in > div {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
}
.IssueCheck_receiptInfoCheck__Um8in i {
  margin-right: 5px;
  font-size: 16px;
  color: #555;
}

/* Список товаров */
.IssueCheck_productsList__NlJQX {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 10px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin: 10px 0;
  overflow-x: auto;
  list-style: none;
}
.IssueCheck_productItem__1LePE {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #333;
  flex-wrap: nowrap;
}
.IssueCheck_productName__sXBYc {
  white-space: nowrap;
  flex: 1 1 auto;
}
.IssueCheck_productactual_quantity__a4WUp,
.IssueCheck_productPrice__\\+Yngs {
  white-space: nowrap;
}

/* Адаптив */
@media (max-width: 600px) {
  .IssueCheck_productsList__NlJQX {
    padding: 8px;
    gap: 8px;
  }
  .IssueCheck_productItem__1LePE {
    font-size: 12px;
    gap: 8px;
  }
  .IssueCheck_receiptInfoCheck__Um8in i {
    font-size: 14px;
    margin-right: 4px;
  }
}

/* Контакты и способы оплаты */
.IssueCheck_contactWrapper__FrBCB {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  flex-wrap: wrap;
}
.IssueCheck_paymentOptions__yjNWi,
.IssueCheck_contactWrapper__FrBCB /* if you want same wrapper for contacts */ {
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  margin: 15px 0;
}
.IssueCheck_paymentOption__4CVkE,
.IssueCheck_contactOption__zrVu3 {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(50% - 10px);
  box-sizing: border-box;
  height: 40px;
  padding: 10px;
  border: 1px solid #ccc;
  background-color: #f0f0f0;
  border-radius: 6px;
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  word-wrap: break-word;
  white-space: normal;
  transition: background-color 0.2s, border-color 0.2s;
}
.IssueCheck_paymentOption__4CVkE:hover,
.IssueCheck_contactOption__zrVu3:hover {
  background-color: #e0e0e0;
}
.IssueCheck_paymentOption__4CVkE.IssueCheck_selected__xDvzh,
.IssueCheck_contactOption__zrVu3.IssueCheck_selected__xDvzh {
  background-color: rgb(0, 123, 255);
  border-color: rgb(0, 123, 255);
  color: #fff;
}

/* Группы ввода */
.IssueCheck_inputGroup__ew9XB {
  margin-bottom: 0.5rem;
}
.IssueCheck_inputGroup__ew9XB .IssueCheck_label__zOAG8 {
  display: block;
  font-size: 0.85rem;
  margin-bottom: 0.2rem;
  font-weight: bold;
}

/* Инпуты со иконкой (если нужны) */
.IssueCheck_inputGroupContainer__DMaeo {
  padding: 0.15rem;
}
.IssueCheck_withIcon__jagoL {
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 30px;
  padding: 0 0.3rem;
}
.IssueCheck_withIcon__jagoL input {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 0.85rem;
  background-color: transparent;
}
.IssueCheck_editIcon__BLXT2 {
  font-size: 1rem;
  color: #007bff;
  cursor: pointer;
  margin-left: 0.3rem;
}

/* Ошибки */
.IssueCheck_error__9VSfB {
  color: red;
  margin-top: 6px;
  text-align: center;
  font-size: 0.85rem;
}

/* Кнопки */
.IssueCheck_actionGroup__ickT7 {
  margin-top: 1rem;
}
.IssueCheck_issueButton__A3Ut9,
.IssueCheck_closeButton__E8K4Q {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: bold;
}
.IssueCheck_issueButton__A3Ut9 {
  background-color: rgb(0, 123, 255);
  color: #fff;
  margin-bottom: 10px;
}
.IssueCheck_closeButton__E8K4Q {
  background-color: #ffd700;
  color: #fff;
}

/* Детали пробитого чека */
.IssueCheck_checkDetails__MHjid {
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}
.IssueCheck_checkDetails__MHjid h3 {
  color: #4caf50;
  font-size: 1.2rem;
  margin-bottom: 15px;
  text-align: center;
}
.IssueCheck_checkDetails__MHjid ul {
  list-style: none;
  padding: 0;
  font-size: 0.9rem;
}
.IssueCheck_checkDetails__MHjid li {
  margin-bottom: 8px;
}
.IssueCheck_checkDetails__MHjid li strong {
  font-weight: bold;
}

/* Действия под деталями чека */
.IssueCheck_checkActions__2OVLu {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 15px;
}
.IssueCheck_checkActions__2OVLu button {
  padding: 8px 16px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color 0.2s;
}
.IssueCheck_checkActions__2OVLu button:hover {
  background-color: #0056b3;
}
.IssueCheck_checkActions__2OVLu button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Courier/CourierModal/styles/IssueCheck.module.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB,qCAAmB,UAAU,YAAY,iBAAiB,EAAE;AAC5D,qCAAmB,cAAc,QAAQ;AACzC,sCAAmB,uBAAuB,EAAE;AAC5C,qCAAmB,cAAc,QAAQ;;AAEzC,2BAA2B;AAC3B;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE;IACE,YAAY;IACZ,QAAQ;EACV;EACA;IACE,eAAe;IACf,QAAQ;EACV;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;AACA;;EAEE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,cAAc;AAChB;AACA;;EAEE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,oDAAoD;AACtD;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,kCAAkC;EAClC,8BAA8B;EAC9B,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":["/* Обёртка всей формы */\r\n.formContainer {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  padding: 10px;\r\n  padding-bottom: 70px;\r\n  overflow-y: auto;\r\n  background-color: #fdfdfd;\r\n  font-family: sans-serif;\r\n}\r\n\r\n/* Заголовок */\r\n.heading {\r\n  margin-top: 0;\r\n  text-align: center;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n/* Статусы обработки */\r\n.statusError     { color: red;           font-weight: bold; }\r\n.statusPending   { color: #ff9800;       }\r\n.statusCompleted { color: rgb(0, 123, 255); }\r\n.statusUnknown   { color: #607d8b;       }\r\n\r\n/* Информация о квитанции */\r\n.receiptInfoCheck {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 15px;\r\n  padding: 10px;\r\n  background-color: #f9f9f9;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n}\r\n.receiptInfoCheck > div {\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 14px;\r\n  color: #333;\r\n}\r\n.receiptInfoCheck i {\r\n  margin-right: 5px;\r\n  font-size: 16px;\r\n  color: #555;\r\n}\r\n\r\n/* Список товаров */\r\n.productsList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n  padding: 10px;\r\n  background-color: #f9f9f9;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  margin: 10px 0;\r\n  overflow-x: auto;\r\n  list-style: none;\r\n}\r\n.productItem {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  font-size: 14px;\r\n  color: #333;\r\n  flex-wrap: nowrap;\r\n}\r\n.productName {\r\n  white-space: nowrap;\r\n  flex: 1 1 auto;\r\n}\r\n.productactual_quantity,\r\n.productPrice {\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Адаптив */\r\n@media (max-width: 600px) {\r\n  .productsList {\r\n    padding: 8px;\r\n    gap: 8px;\r\n  }\r\n  .productItem {\r\n    font-size: 12px;\r\n    gap: 8px;\r\n  }\r\n  .receiptInfoCheck i {\r\n    font-size: 14px;\r\n    margin-right: 4px;\r\n  }\r\n}\r\n\r\n/* Контакты и способы оплаты */\r\n.contactWrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  width: 100%;\r\n  flex-wrap: wrap;\r\n}\r\n.paymentOptions,\r\n.contactWrapper /* if you want same wrapper for contacts */ {\r\n  display: flex;\r\n  flex-wrap: nowrap;\r\n  gap: 10px;\r\n  margin: 15px 0;\r\n}\r\n.paymentOption,\r\n.contactOption {\r\n  flex: 0 0 calc(50% - 10px);\r\n  box-sizing: border-box;\r\n  height: 40px;\r\n  padding: 10px;\r\n  border: 1px solid #ccc;\r\n  background-color: #f0f0f0;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 0.9rem;\r\n  word-wrap: break-word;\r\n  white-space: normal;\r\n  transition: background-color 0.2s, border-color 0.2s;\r\n}\r\n.paymentOption:hover,\r\n.contactOption:hover {\r\n  background-color: #e0e0e0;\r\n}\r\n.paymentOption.selected,\r\n.contactOption.selected {\r\n  background-color: rgb(0, 123, 255);\r\n  border-color: rgb(0, 123, 255);\r\n  color: #fff;\r\n}\r\n\r\n/* Группы ввода */\r\n.inputGroup {\r\n  margin-bottom: 0.5rem;\r\n}\r\n.inputGroup .label {\r\n  display: block;\r\n  font-size: 0.85rem;\r\n  margin-bottom: 0.2rem;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Инпуты со иконкой (если нужны) */\r\n.inputGroupContainer {\r\n  padding: 0.15rem;\r\n}\r\n.withIcon {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  height: 30px;\r\n  padding: 0 0.3rem;\r\n}\r\n.withIcon input {\r\n  flex: 1;\r\n  border: none;\r\n  outline: none;\r\n  font-size: 0.85rem;\r\n  background-color: transparent;\r\n}\r\n.editIcon {\r\n  font-size: 1rem;\r\n  color: #007bff;\r\n  cursor: pointer;\r\n  margin-left: 0.3rem;\r\n}\r\n\r\n/* Ошибки */\r\n.error {\r\n  color: red;\r\n  margin-top: 6px;\r\n  text-align: center;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n/* Кнопки */\r\n.actionGroup {\r\n  margin-top: 1rem;\r\n}\r\n.issueButton,\r\n.closeButton {\r\n  width: 100%;\r\n  padding: 12px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.95rem;\r\n  font-weight: bold;\r\n}\r\n.issueButton {\r\n  background-color: rgb(0, 123, 255);\r\n  color: #fff;\r\n  margin-bottom: 10px;\r\n}\r\n.closeButton {\r\n  background-color: #ffd700;\r\n  color: #fff;\r\n}\r\n\r\n/* Детали пробитого чека */\r\n.checkDetails {\r\n  padding: 10px;\r\n  background-color: #f9f9f9;\r\n  border-radius: 8px;\r\n  box-shadow: 0 0 10px rgba(0,0,0,0.1);\r\n}\r\n.checkDetails h3 {\r\n  color: #4caf50;\r\n  font-size: 1.2rem;\r\n  margin-bottom: 15px;\r\n  text-align: center;\r\n}\r\n.checkDetails ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  font-size: 0.9rem;\r\n}\r\n.checkDetails li {\r\n  margin-bottom: 8px;\r\n}\r\n.checkDetails li strong {\r\n  font-weight: bold;\r\n}\r\n\r\n/* Действия под деталями чека */\r\n.checkActions {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  margin-top: 15px;\r\n}\r\n.checkActions button {\r\n  padding: 8px 16px;\r\n  background-color: #007bff;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-size: 0.9rem;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n.checkActions button:hover {\r\n  background-color: #0056b3;\r\n}\r\n.checkActions button:disabled {\r\n  background-color: #ccc;\r\n  cursor: not-allowed;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `IssueCheck_formContainer__bZVVX`,
	"heading": `IssueCheck_heading__2t0dU`,
	"statusError": `IssueCheck_statusError__sVAUf`,
	"statusPending": `IssueCheck_statusPending__SILyK`,
	"statusCompleted": `IssueCheck_statusCompleted__3L+84`,
	"statusUnknown": `IssueCheck_statusUnknown__bsV4b`,
	"receiptInfoCheck": `IssueCheck_receiptInfoCheck__Um8in`,
	"productsList": `IssueCheck_productsList__NlJQX`,
	"productItem": `IssueCheck_productItem__1LePE`,
	"productName": `IssueCheck_productName__sXBYc`,
	"productactual_quantity": `IssueCheck_productactual_quantity__a4WUp`,
	"productPrice": `IssueCheck_productPrice__+Yngs`,
	"contactWrapper": `IssueCheck_contactWrapper__FrBCB`,
	"paymentOptions": `IssueCheck_paymentOptions__yjNWi`,
	"paymentOption": `IssueCheck_paymentOption__4CVkE`,
	"contactOption": `IssueCheck_contactOption__zrVu3`,
	"selected": `IssueCheck_selected__xDvzh`,
	"inputGroup": `IssueCheck_inputGroup__ew9XB`,
	"label": `IssueCheck_label__zOAG8`,
	"inputGroupContainer": `IssueCheck_inputGroupContainer__DMaeo`,
	"withIcon": `IssueCheck_withIcon__jagoL`,
	"editIcon": `IssueCheck_editIcon__BLXT2`,
	"error": `IssueCheck_error__9VSfB`,
	"actionGroup": `IssueCheck_actionGroup__ickT7`,
	"issueButton": `IssueCheck_issueButton__A3Ut9`,
	"closeButton": `IssueCheck_closeButton__E8K4Q`,
	"checkDetails": `IssueCheck_checkDetails__MHjid`,
	"checkActions": `IssueCheck_checkActions__2OVLu`
};
export default ___CSS_LOADER_EXPORT___;
